

const Permissions = {
  CHEQUE: {
    label: 'Cheque',
    code: 'PERM_CHEQUE',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_CHEQUE_ENTIRE_APP' },
      { label: 'Dashboard', code: 'PERM_CHEQUE_DASHBOARD' },
      { label: 'Cheque Form', code: 'PERM_CHEQUE_FORM' },
      { label: 'Cheque History', code: 'PERM_CHEQUE_HISTORY' },

    
      { label: "Manage Configuration", code: "PERM_CHEQUE_MANAGE_CONFIGURATION" },

    ]
  },
  GENERALLEDGER: {
    label: 'General Ledger',
    code: 'PERM_GENERAL',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_GENERALLEDGER_ENTIRE_APP' },
      { label: 'Add Invoice', code: 'PERM_GENERALLEDGER_ADD_INVOICE' },
      { label: 'Pay Invoice', code: 'PERM_PAY_INVOICE' },
      { label: 'ATM', code: 'PERM_GENERALLEDGER_ATM' },
      { label: 'Bank', code: 'PERM_GENERALLEDGER_BANK' },
      { label: 'Owner Distribution', code: 'PERM_GENERALLEDGER_OWNER_DISTRIBUTION' },
      { label: 'Other Income', code: 'PERM_GENERALLEDGER_OTHER_INCOME' },
      { label: 'Sales Tax', code: 'PERM_GENERALLEDGER_SALES_TAX' },
      { label: 'Bank Ledger', code: 'PERM_GENERALLEDGER_BANK_LEDGER' },
      { label: 'Cash Ledger', code: 'PERM_GENERALLEDGER_CASH_LEDGER' },
      { label: 'Owners Ledger & Planning', code: 'PERM_GENERALLEDGER_OWNERS_LEDGER' },

  
      { label: "Manage Configuration", code: "PERM_GL_MANAGE_CONFIGURATION" },
      { label: "Other Income Type", code: "PERM_GL_OTHER_INCOMETYPE" },
      { label: "ManageSettings", code: "PERM_GL_MANAGE_SETTINGS" }
    ]
  },
  SALES: {
    label: 'Sales',
    code: 'PERM_SALES',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_SALES_ENTIRE_APP' },
      { label: 'Quick Invoice', code: 'PERM_QUICK_INVOICE' },
      { label: 'Retails Invoice', code: 'PERM_RETAILS_INVOICE' },
      { label: 'Wholesale', code: 'PERM_WHOLESALE_INVOICE' },
      { label: 'Business Report', code: 'PERM_BUSINESS_REPORT' },
      { label: 'Quick History', code: 'PERM_QUICK_HISTORY' },
      { label: 'Retail History', code: 'PERM_RETAIL_HISTORY' },
      { label: 'Wholesale History', code: 'PERM_WHOLESALE_HISTORY' },

    
      { label: "Manage Configuration", code: "PERM_SALE_MANAGE_CONFIGURATION" },
      { label: "Manage Vendor", code: "PERM_SALE_MANAGE_VENDOR" },
      { label: "Manage Departments", code: "PERM_SALE_MANAGE_DEPARTMENTS" },
      { label: "Manage Expense Type", code: "PERM_SALE_MANAGE_EXPENSE_TYPE" }

    ]
  },
  INVENTORY: {
    label: 'Inventory',
    code: 'PERM_INVENTORY',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_INVENTORY_ENTIRE_APP' },
      { label: ' Dashboard', code: 'PERM_INVENTORY_DASHBOARD' },
      { label: 'Product', code: 'PERM_PRODUCT' },
      { label: 'Product Inventory', code: 'PERM_PRODUCT_INVENTORY' },
      { label: 'Manage Stock', code: 'PERM_MANAGE_STOCK' },


      { label: "Manage Configuration", code: "PERM_INVENTORY_MANAGE_CONFIGURATION" },
      { label: "Manage Vendor", code: "PERM_INVENTORY_MANAGE_VENDOR" },
      { label: "Manage Departments", code: "PERM_INVENTORY_MANAGE_DEPARTMENTS" },
      { label: "Manage Expense Type", code: "PERM_INVENTORY_MANAGE_EXPENSE_TYPE" }
    ]
  },
  POS: {
    label: 'pos',
    code: 'PERM_POS',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_POS_ENTIRE_APP' },
      { label: ' Dashboard', code: 'PERM_POS_DASHBOARD' },
      { label: 'Transaction', code: 'PERM_POS_TRANSACTION' },
      { label: 'Product Setting', code: 'PERM_PRODUCT_SETTING' },

      { label: "Manage Configuration", code: "PERM_POS_MANAGE_CONFIGURATION" },
    ]
  },
  PAYROLL: {
    label: 'Payroll',
    code: 'PERM_PAYROLL',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_PAYROLL_ENTIRE_APP' },
      { label: ' Dashboard', code: 'PERM_PAYROLL_DASHBOARD' },
      { label: 'Manual payroll', code: 'PERM_MANUAL_PAYROLL' },
      { label: 'Biometric Payroll', code: 'PERM_BIOMETRIC_PAYROLL' },

      { label: "Manage Configuration", code: "PERM_PAYROLL_MANAGE_CONFIGURATION" },
      { label: "Manage Settings", code: "PERM_PAYROLL_MANAGE_SETTINGS" }
    ]
  },

  TIMECARD: {
    label: 'Timecard',
    code: 'PERM_TIMECARD',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_TIMECARD_ENTIRE_APP' },
      { label: ' Dashboard', code: 'PERM_TIMECARD_DASHBOARD' },
      { label: 'Attendance Register', code: 'PERM_TIMECARD_ATTENDANCE_REGISTER' },
      { label: 'Employee Enrollment', code: 'PERM_EMPLOYEE_ENROLLMENT' },
      { label: 'Employee Log', code: 'PERM_EMPLOYEE_LOG' },
      { label: "Manage Configuration", code: "PERM_TIMECARD_MANAGE_CONFIGURATION" }
    ]
  },
  SPENDSTRACKING: {
    label: 'Spends Tracking',
    code: 'PERM_SPENDS_TRACKING',
    children: [
      // { label: 'Entire App Visible', code: 'PERM_SPENDS_ENTIRE_APP' },
      { label: ' Expense', code: 'PERM_SPENDS_EXPENSE' },
      { label: 'Purchase', code: 'PERM_SPENDS_PURCHASE' },
      { label: 'Expense Invoice', code: 'PERM_SPENDS_EX-INVOICE' },
      { label: 'Purchase Invoice', code: 'PERM_SPENDS_PUR-INVOICE' },
      { label: 'Pay Invoice', code: 'PERM_PAY_INVOICE' },

   
      { label: "Manage Configuration", code: "PERM_SPENDS_MANAGE_CONFIGURATION" },
      { label: "Manage Vendor", code: "PERM_SPENDS_MANAGE_VENDOR" },
      { label: "Manage Departments", code: "PERM_SPENDS_MANAGE_DEPARTMENTS" },
      { label: "Manage Expense Type", code: "PERM_SPENDS_MANAGE_EXPENSE_TYPE" },
      { label: "Manage Settings", code: "PERM_SPENDS_MANAGE_SETTINGS" }

    ]
  },
  GAS: {
    label: "Gas",
    code: "PERM_GAS",
    children: [
      // { label: "Entire App Visible", code: "PERM_GAS_ENTIRE_APP" },
      { label: "Dashboard", code: "PERM_GAS_DASHBOARD" },
      { label: "Gas Invoice", code: "PERM_GAS_INVOICE" },
      { label: "Gas Tax Settings", code: "PERM_GAS_TAX_SETTINGS" },
      { label: "Gas Settings", code: "PERM_GAS_SETTINGS" },

      { label: "Manage Configuration", code: "PERM_GAS_MANAGE_CONFIGURATION" },
    ]
  },
  Lottery: {
    label: "Lottery",
    code: "PERM_LOTTERY",
    children: [
      // { label: "Entire App Visisble", code: "PERM_LOTTERY_ENTIRE_APP" },
      { label: "Dashboard", code: "PERM_LOTTERY_DASHBOARD" },
      { label: "Lottery Operations", code: "PERM_LOTTERY" },
      { label: "Daily Lottery", code: "PERM_DAILY_LOTTERY" }
    ]
  },
  LEGAL: {
    label: "Legal Manage",
    code: "PERM_LEGAL",
    children: [
      { label: "Dashboard", code: "PERM_LEGAL_DASHBOARD" },
      { label: "Templates", code: "PERM_LEGAL_TEMPLATES" },
      // { label: "Legal Documents", code: "PERM_LEGAL_DOCUMENTS" },
      { label: "Legal Documents", code: "PERM_LEGAL_DOCUMENTS" },
      { label: "Signed Documnets", code: "PERM_LEGAL_SIGNED_DOCUMENTS" },
      { label: "Document Assigning", code: "PERM_LEGAL_DOCUMENT_SIGNING" },
      { label: "Audit Logs", code: "PERM_LEGAL_AUDIT_LOGS" },
      // { label: "Manage Configuration", code: "PERM_LEGAL_MANAGE_CONFIGURATION" },
      // { label: "Manage Settings", code: "PERM_LEGAL_MANAGE_SETTINGS" }
    ]
  },
   ASSET: {
    label: "Asset Management System",
    code: "PERM_ASSET",
    children: [
      { label: "Dashboard", code: "PERM_ASSET_DASHBOARD" },
      { label: "Category", code: "PERM_ASSET_CATEGORY" },
      { label: "Asset Inventory", code: "PERM_ASSET_INVENTORY" },
      { label: "Asset Request", code: "PERM_ASSET_REQUEST" },
      { label: "Asset Request List", code: "PERM_ASSET_REQUEST_LIST" },
      { label: "Asset Allocation", code: "PERM_ASSET_ALLOCATION" },
      { label: "Asset Maintenance", code: "PERM_ASSET_MAINTENANCE" },
      { label: "Maintenance Cost", code: "PERM_ASSET_MAINTENANCE_COST" },
      { label: "RFQ Management ", code: "PERM_ASSET_RFQManagement" },
     
    ]
  }
};

export default Permissions;
